export const COMPONENT_DESELECTED = 'preview/COMPONENT_DESELECTED';
export const COMPONENT_HOVER_ENTER = 'preview/COMPONENT_HOVER_ENTER';
export const COMPONENT_HOVER_LEAVE = 'preview/COMPONENT_HOVER_LEAVE';
export const COMPONENT_SELECTED = 'preview/COMPONENT_SELECTED';
export const DEVICE_SELECTED = 'preview/DEVICE_SELECTED';

export const EMPTY_COMPONENT_PAYLOAD = {
  Id: '',
  variantIds: [],
  childComponentIds: []
};
export const IFRAME_MESSAGE = {
  DESELECTING: 'deselecting',
  HOVER_ENTER: 'hover enter',
  HOVER_LEAVE: 'hover leave',
  SELECTING: 'selecting',
  SEND_PAYLOAD: 'send payload',
  TOGGLE_POINTER_EVENTS: 'toggle pointer events',
  CANVAS: 'CANVAS'
};
export const ID = {
  FRAME_CONTAINER: 'frameContainer',
  COMPONENT_LIST: 'componentList',
  CONTEXT_MENU: 'contextMenu'
};
export const IS_MOBILE = 'preview/IS_MOBILE';
export const UPDATED_CONTENT_CONTEXT = 'preview/UPDATED_CONTENT_CONTEXT';
export const UPDATED_HIDDEN_EXPERIMENTS = 'preview/UPDATED_HIDDEN_EXPERIMENTS';
export const SET_CONTENT_LINK_STATUS = 'preview/SET_CONTENT_LINK_STATUS';
export const SET_MWP_IFRAME_REF = 'preview/SET_MWP_IFRAME_REF';
export const PREVIEW_ENV = 'https://canvas-preview.mwp.vip.nordstrom.com';
